import {lang} from './localization';
import {createInertiaApp} from '@inertiajs/vue2';
import GlobalLayout from '../layouts/GlobalLayout.vue';
import VueApexCharts from 'vue-apexcharts';
import PortalVue from 'portal-vue';

import Toasts from '../components/Toasts';
import AccountSetup from '../pages/AccountSetup/AccountSetup';
import UserInitials from '@components/User/UserInitials.vue';

window.__ = function (key, replacements = null, locale = null) {
    return lang.get(key, replacements, locale);
};
Vue.prototype.__ = window.__;
Vue.prototype.$csrf_token = function () {
    return document.querySelector('meta[name="csrf-token"]').content;
};
Vue.prototype.$dreamlifterApi = function () {
    return atob(document.querySelector('meta[name="dl"]').content);
};
Vue.prototype.$websocketToken = function () {
    return atob(document.querySelector('meta[name="ws"]').content);
};
Vue.prototype.$websocketHost = function () {
    return atob(document.querySelector('meta[name="wsh"]').content);
};
Vue.prototype.$frontendUrl = function () {
    return atob(document.querySelector('meta[name="frontend"]').content);
};
Vue.prototype.$storeManagerApi = function () {
    return atob(document.querySelector('meta[name="sm"]').content);
};
Vue.prototype.$route = function (name, parameters) {
    return route(name, parameters);
};
Vue.prototype.$localDate = function (timestamp, options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
}) {
    let date = timestamp;
    if (!(timestamp instanceof Date)) {
        date = new Date(timestamp);
        if (date.getFullYear() === 1970) {
            date = new Date(timestamp * 1000);
        }
    }
    return date.toLocaleDateString(document.documentElement.lang, options);
};
Vue.prototype.$localTime = function (timestamp, options = {
    hour: '2-digit',
    minute: '2-digit',
}) {
    let date = timestamp;
    if (!(timestamp instanceof Date)) {
        date = new Date(timestamp);
    }
    return date.toLocaleTimeString(document.documentElement.lang, options);
};
Vue.prototype.$localDateTime = function (timestamp, options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
}) {
    let date = timestamp;
    if (!(timestamp instanceof Date)) {
        date = new Date(timestamp);
    }
    return date.toLocaleTimeString(document.documentElement.lang, options);
};
Vue.prototype.$localCurrency = function (number, currency = 'EUR') {
    return new Intl.NumberFormat(navigator.language, {style: 'currency', currency: currency}).format(
        number);
};
Vue.prototype.$convertTimestampForDateTimeLocalInput = function (timestamp) {
    let date = timestamp;
    if (!(timestamp instanceof Date)) {
        date = new Date(timestamp);
    }

    let offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - (offset * 60 * 1000));

    return date.toISOString().replace(/\.\d+Z$/, '');
};
Vue.prototype.$initials = function (name) {
    return initials(name);
};
Vue.prototype.$locale = document.documentElement.lang;
Vue.prototype.$lang = lang;
window.lang = lang; //Remove once everything is vue
Vue.prototype.$storePermissions = [];

const slugify = require('slugify');
Vue.prototype.$slugify = function (text) {
    return slugify(text, {
        replacement: '-',  // replace spaces with replacement character, defaults to `-`
        remove: undefined, // remove characters that match regex, defaults to `undefined`
        lower: true,       // convert to lower case, defaults to `false`
        strict: false,     // strip special characters except replacement, defaults to `false`
        locale: 'de',      // language code of the locale to use
        trim: true         // trim leading and trailing replacement chars, defaults to `true`
    });
};

//3rd party vue components
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.use(PortalVue);

new Vue({
    el: '#app',
    components: {
        Toasts,
        AccountSetup,
        UserInitials,

    },
});

//InertiaVue
if (document.getElementById('inertia_app')) {
    createInertiaApp({
        resolve: name => {
            const page = require(`../pages/${name}`).default;
            page.layout = page.layout || GlobalLayout;
            return page;
        },
        setup({el, App, props, plugin}) {
            Vue.use(plugin);

            new Vue({
                render: h => h(App, props),
            }).$mount(el);
        },
        progress: {
            // The delay after which the progress bar will appear, in milliseconds...
            delay: 250,

            // The color of the progress bar...
            color: '#7a5dec',

            // Whether to include the default NProgress styles...
            includeCSS: true,

            // Whether the NProgress spinner will be shown...
            showSpinner: false,
        },
    });
}
